import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper/modules";
import { motion, AnimatePresence } from "motion/react";
import ProgressBar from "./components/MintBar";

import { useWhitelistMint } from "@/hooks/useWhitelistMint";
import { useTotalSupply } from "@/hooks/useTotalSupply";
import { useAccount, useConnect } from "wagmi";

import "swiper/css";
import "swiper/css/effect-cards";
import style from "./style.module.scss";
import sdk from "@farcaster/miniapp-sdk";
import { MINTED_SHARE_TEXT } from "@/constants/share";
import { MINIAPP_SHARE_URL, OPENSEA_URL } from "@/constants/url";
import { TOTAL_SUPPLY, FAKE_TOTAL } from "@/constants/mint";
import { formatNumber, toNumber } from "@/utils/string";
import toast from "react-hot-toast";

const nfts = [
  { id: 1, image: "/images/7.png" },
  { id: 2, image: "/images/2.png" },
  { id: 3, image: "/images/4.png" },
  { id: 4, image: "/images/8.png" },
  { id: 5, image: "/images/11.png" },
  { id: 6, image: "/images/14.png" },
  { id: 7, image: "/images/21.png" },
  { id: 8, image: "/images/25.png" },
];

const MintView = () => {
  const swiperRef = useRef<any>(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const { isConnected } = useAccount();
  const { connect, connectors } = useConnect();

  const totalSupply = useTotalSupply();
  const { isSuccess, handleMint } = useWhitelistMint();

  const closeModal = () => setShowSuccessModal(false);

  const displayTotalSupply =
    toNumber(totalSupply) >= FAKE_TOTAL ? FAKE_TOTAL : toNumber(totalSupply);

  useEffect(() => {
    if (isSuccess) setShowSuccessModal(true);
  }, [isSuccess]);

  const handleClickMint = async () => {
    if (!isConnected) connect({ connector: connectors[0] });
    else {
      try {
        await handleMint();
      } catch (err) {
        console.error("Failed to mint NFT:", err);
        toast.error("Failed to mint NFT. Please refresh and try again.", {
          duration: 3000,
        });
      }
    }
  };

  const handleOpenSea = () => {
    window.open(OPENSEA_URL, "_blank");
  };

  const handleShare = async () => {
    await sdk.actions.composeCast({
      text: MINTED_SHARE_TEXT,
      embeds: [MINIAPP_SHARE_URL],
    });
  };

  return (
    <>
      <div className={style.wrapper}>
        <h1 className={style.title}>Boxes — NFT Collection</h1>
        <p className={style.subtitle}>
          {formatNumber(TOTAL_SUPPLY)} Boxes for $Boxes
        </p>

        <div className={style.sliderBox}>
          <button
            className={style.navButton}
            onClick={() => swiperRef.current?.slidePrev()}
          >
            ‹
          </button>

          <Swiper
            effect="cards"
            grabCursor={true}
            initialSlide={0}
            loop={true}
            modules={[EffectCards]}
            className={style.swiper}
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
          >
            {nfts.map((item, index) => (
              <SwiperSlide key={index}>
                <div className={style.slideContent}>
                  <img src={item.image} className={style.nftImage} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button
            className={style.navButton}
            onClick={() => swiperRef.current?.slideNext()}
          >
            ›
          </button>
        </div>

        <ProgressBar value={displayTotalSupply} total={TOTAL_SUPPLY} />

        <div className={style.mintRow}>
          <div
            className={`${style.mintBtn} button-flat`}
            onClick={handleClickMint}
          >
            <span>FREE MINT</span>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {showSuccessModal && (
          <>
            <motion.div
              className={style.modalOverlay}
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.7 }}
              exit={{ opacity: 0 }}
              onClick={closeModal}
            />

            <motion.div
              className={style.modal}
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.85 }}
              transition={{ duration: 0.25 }}
            >
              <h2>🎉 Mint successful</h2>
              <p>
                Your Kawaii PFPs are sparkling <br /> on OpenSea now
              </p>

              <div className={style.shareWrapper}>
                <button className={style.shareButton} onClick={handleShare}>
                  <img src="/images/share.svg" alt="" />
                </button>
                <button className={style.shareButton} onClick={handleOpenSea}>
                  <img src="/images/opensea.svg" alt="" />
                </button>
              </div>

              <button
                className="button-flat"
                style={{ borderRadius: "4px", width: "100%" }}
                onClick={closeModal}
              >
                Close
              </button>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default MintView;
